<template lang="pug">
  div.hour-line
    vein-tips(v-for="item in activeTips",
              :key="item.publishTime",
              :item="item",
              :close-tips="closeTips",
              :update-position="updatePosition",
              :range="range")
    Loading(v-if="!hourLineLoaded")
</template>
<script>
import * as d3 from 'd3'
import VeinTips from './VeinTips'
import moment from 'moment'
import Loading from '../components/Loading'
import {toThousands} from '../config/config'
moment.locale('zh-cn')
export default {
  name: 'HourLine',
  props: ['lineData', 'hourLineLoaded', 'venationHour', 'nodes'],
  data () {
    return {
      activeTips: [],
      range: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
      showVenations: null
    }
  },
  watch: {
    hourLineLoaded: function (val) {
      if (val === true) {
        this.renderChart()
      }
    }
  },
  updated () {

  },
  methods: {
    updatePosition () {},
    closeTips (item) {
      this.activeTips = this.activeTips.filter(d => !(d.publishTime === item.publishTime))
    },
    renderChart () {
      let w = this.$el.clientWidth
      let h = this.$el.clientHeight
      let data = this.lineData.map((d, i) => {
        return Object.assign({}, d, {
          active: i === 0
        })
      })
      let nodes = this.nodes
      let venation = this.venationHour
      let margin = {
        top: 15,
        left: 50,
        bottom: 35,
        right: 45
      }
      let periodHeight = 20
      let width = w - margin.left - margin.right
      let height = h - margin.top - margin.bottom
      let alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
      let legends = d3.select(this.$el)
        .append('ul')
        .attr('class', 'legends')
      let dom = d3.select(this.$el)
      let svg = d3.select(this.$el)
        .append('svg')
        .attr('width', w)
        .attr('height', h)
      svg.append('defs').append('clipPath')
        .attr('id', 'clip')
        .append('rect')
        .attr('width', width)
        .attr('height', height)

      let context = svg.append('g')
        .attr('class', 'context')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        .style('clip-path', 'url(#clip)')

      let background = svg.append('rect')
        .attr('width', width)
        .attr('height', height)
        .attr('class', 'zoom')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        .style('fill', 'transparent')

      let points = svg.append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
      let timePointTips = svg.append('g')
        .style('opacity', 0)
        .attr('class', 'time-point-tips')
      timePointTips.append('line')
        .attr('x1', 0)
        .attr('x2', 0)
        .attr('y1', margin.top)
        .attr('y2', height)
        .style('stroke', '#000')
        .style('stroke-width', 1)
        .style('opacity', 0.1)

      let xAxes = svg.append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top + height})`)
        .attr('class', 'x-axis axis')
      let x = d3.scaleTime()
        .range([0, width])

      let xOrigin = d3.scaleTime()
        .range([0, width])

      let y = d3.scaleLinear()
        .range([height, 0])

      let xAxis = d3
        .axisBottom(x)
        .tickSizeInner(-height)
        .tickSizeOuter(0)
        .tickFormat(d3.timeFormat('%Y-%m-%d %H'))
        .tickPadding(15)
        // .ticks(6)
        // console.log()
      let yAxis = d3
        .axisLeft(y)
        .tickSizeInner(-width)
        .tickSizeOuter(0)
        .ticks(6)
      let linePath = d3.line()
        .x(d => x(d.publishTime))
        .y(d => y(d.num))
        .curve(d3.curveMonotoneX)

      // ----------------数据计算---------------------------
      let times = data[0].hour.lineHour.map(d => d)
      let pos = data[1].hour.lineHour.map(d => d)
      let neu = data[2].hour.lineHour.map(d => d)
      let neg = data[3].hour.lineHour.map(d => d)
      let tipsValue = times.map((d, i) => {
        return Object.assign({}, d, {
          all: d.num,
          pos: pos[i].num,
          neu: neu[i].num,
          neg: neg[i].num
        })
      })
      // let timeValues = times.map(d => d.publishTime)
      // venation.lurk.start = d3.min(times.map(d => d.publishTime))
      // venation.recession.end = d3.max(times.map(d => d.publishTime))
      let timeExt = [venation.lurk.start, d3.max(times.map(d => d.publishTime))]
      x.domain(timeExt)
      xOrigin.domain(timeExt)
      xAxis.tickValues(getXValues(x.domain().map(d => +d), 5))

      function getXValues (range, num) {
        let [start, end] = range
        let step = (end - start) / num
        let values = []
        for (let i = 0; i <= num; i++) {
          let value = start + i * step
          values.push(value)
        }
        return values
      }
      getXValues(x.domain().map(d => +d))

      let high = data[0].hour.high
      let mean = data[0].hour.avg
      let maxY = d3.max(data.filter(d => d.active)
        .map(d => {
          return d.hour.lineHour.map(d => d.num)
        })
        .reduce((a, b) => {
          return a.concat(b)
        }, []))
      let yExt = [0, maxY * 1.2]
      y.domain(yExt)

      let periodsData = [
        Object.assign({},
          venation.lurk,
          {
            name: '上升期',
            alias: 'lurk',
            color: 'rgba(57,137,203,0.1)',
            active: false
          }),
        Object.assign({},
          venation.hot,
          {
            name: '热议期',
            alias: 'hot',
            color: 'rgba(57,137,203,0.2)',
            active: false
          }),
        Object.assign({},
          venation.recession,
          {
            name: '衰退期',
            alias: 'recession',
            color: 'rgba(57,137,203,0.3)',
            active: false
          })
      ]

      // ------render-----------------------------------------
      // console.log(periodsData)
      let periods = context.append('g')
        .attr('class', 'periods')
        .attr('transform', `translate(0, ${height - periodHeight})`)

      function renderPeriods () {
        periods.selectAll('g.period')
          .data(periodsData)
          .enter()
          .append('g')
          .attr('transform', d => `translate(${x(d.start)})`)
          .attr('class', 'period')

        periods.selectAll('g.period')
          .data(periodsData)
          .attr('transform', d => `translate(${x(d.start)})`)
          .each(function (e) {
            let dom = d3.select(this)
            let rect
            let text
            let has = dom.select('rect').size()
            if (has) {
              rect = dom.select('rect')
            } else {
              rect = dom.append('rect')
            }

            if (dom.select('text').size()) {
              text = dom.select('text')
            } else {
              text = dom.append('text')
            }
            rect
              .attr('x', 0)
              .attr('width', x(e.end) - x(e.start))
              .attr('y', d => {
                if (d.active) {
                  return periodHeight - height
                } else {
                  return 0
                }
              })
              .attr('height', d => {
                if (d.active) {
                  return height
                } else {
                  return periodHeight
                }
              })
              .attr('fill', e.color)

            rect
              .transition()
              .duration(has ? 100 : 0)
              .attr('y', d => {
                if (d.active) {
                  return periodHeight - height
                } else {
                  return 0
                }
              })
              .attr('height', d => {
                if (d.active) {
                  return height
                } else {
                  return periodHeight
                }
              })

            text
              .attr('x', (x(e.end) - x(e.start)) / 2)
              .attr('y', periodHeight / 2)
              .attr('dy', 3)
              .text(e.name)
              .style('text-anchor', 'middle')
              .style('dominant-baseline', 'middle')
              .style('fill', '#3989cb')
          })

        periods.selectAll('g.period')
          .data(periodsData)
          .exit()
          .remove()
      }

      renderPeriods()

      xAxes.call(xAxis)

      let yAxes = svg.append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        .attr('class', 'y-axis axis')
      yAxes.call(yAxis)
      let tipsMaxMin = context.append('g')
      renderDataMeanMax()
      function renderDataMeanMax () {
      // 日峰值线
        tipsMaxMin.append('line')
          .attr('class', 'max-line')
          .attr('x1', 0)
          .attr('x2', width)
          .attr('y1', y(high))
          .attr('y2', y(high))
          .style('stroke-dasharray', '10, 2, 2 ,10, 2, 2')
          .style('stroke', '#999999')
          .style('stroke-width', 1)
        tipsMaxMin.append('text')
          .attr('class', 'max-name')
          .attr('x', width)
          .attr('y', y(high))
          .attr('dy', '-0.5em')
          .attr('dx', -30)
          .text('小时峰值')
          .style('text-anchor', 'middle')
          .style('fill', '#999999')

        tipsMaxMin.append('text')
          .attr('class', 'max-value')
          .attr('x', width)
          .attr('y', y(high))
          .attr('dx', -30)
          .attr('dy', '1em')
          .style('text-anchor', 'middle')
          .text(high)
          .style('fill', '#999999')
        // 日均值线
        tipsMaxMin.append('line')
          .attr('class', 'mean-line')
          .attr('x1', 0)
          .attr('x2', width)
          .attr('y1', y(mean))
          .attr('y2', y(mean))
          .style('stroke-dasharray', '10, 2, 2 ,10, 2, 2')
          .style('stroke', '#999999')
          .style('stroke-width', 1)
        tipsMaxMin.append('text')
          .attr('class', 'mean-name')
          .attr('x', width)
          .attr('y', y(mean))
          .attr('dy', '-0.5em')
          .attr('dx', -30)
          .text('小时均值')
          .style('text-anchor', 'middle')
          .style('fill', '#999999')
        tipsMaxMin.append('text')
          .attr('class', 'mean-value')
          .attr('x', width)
          .attr('y', y(mean))
          .attr('dx', -30)
          .attr('dy', '1em')
          .style('text-anchor', 'middle')
          .text(mean)
          .style('fill', '#999999')
      }
      // -------- render legends -------------------------
      function renderLegends () {
        legends.selectAll('li.legend')
          .data(data)
          .enter()
          .append('li')
          .attr('class', d => `legend legend-${d.alias}`)

        legends.selectAll('li.legend')
          .data(data)
          .html(d => {
            return `<i class="dot fa fa-circle" style="color:${d.active ? d.color : '#ccc'};"></i>${d.name}`
          })

        legends.selectAll('li.legend')
          .data(data)
          .exit()
          .remove()
      }

      // -------- render legends -------------------------
      // ----------render line----------------------------

      function renderLines () {
        context.selectAll('path.line')
          .data(data.filter(d => d.active))
          .enter()
          .append('path')
          .attr('class', 'line')

        context.selectAll('path.line')
          .data(data.filter(d => d.active))
          .attr('d', d => linePath(d.hour.lineHour))
          .attr('stroke', d => d.color)
          .attr('stroke-width', 2)
          .attr('fill', 'transparent')
        context.selectAll('path.line')
          .data(data.filter(d => d.active))
          .exit()
          .remove()
      }

      function renderPointer () {
        points.selectAll('g.point-group')
          .remove()
        points.selectAll('g.point-group')
          .data(data.filter(d => d.active))
          .enter()
          .append('g')
          .attr('class', 'point-group')

        points.selectAll('g.point-group')
          .data(data.filter(d => d.active))
          .each(function (e) {
            // -----------add dot --------------
            d3.select(this)
              .selectAll('circle.dot')
              .data(e.hour.nodes)
              .enter()
              .append('circle')
              .attr('class', 'dot')

            d3.select(this)
              .selectAll('circle.dot')
              .data(e.hour.nodes)
              .attr('class', 'dot')
              .attr('cx', d => x(d.publishTime))
              .attr('cy', d => y(e.hour.lineHour.find(n => n.publishTime === d.publishTime).num))
              .attr('r', 4)
              .style('fill', '#fff')
              .style('stroke', e.color)
              .style('stroke-width', 2)

            d3.select(this)
              .selectAll('circle.dot')
              .data(e.hour.nodes)
              .exit()
              .remove()
            // -----------add text --------------

            d3.select(this)
              .selectAll('text.dot-text')
              .data(e.hour.nodes)
              .enter()
              .append('text')
              .attr('class', 'dot-text')

            d3.select(this)
              .selectAll('text.dot-text')
              .data(e.hour.nodes)
              .attr('class', 'dot-text')
              .attr('x', d => x(d.publishTime))
              .attr('y', d => y(e.day.lineHour.find(n => n.publishTime === d.publishTime).num))
              .attr('dy', '-0.5em')
              .style('fill', e.color)
              .style('text-anchor', 'middle')
              .text((d, i) => alpha[i])

            d3.select(this)
              .selectAll('text.dot-text')
              .data(e.hour.nodes)
              .exit()
              .remove()
          })

        points.selectAll('g.point-group')
          .data(data.filter(d => d.active))
          .attr('class', 'point-group')
          .exit()
          .remove()
      }

      renderLines()
      renderPointer()
      renderLegends()
      legends
        .selectAll('li.legend')
        .on('click', (e) => {
          data = data.map(d => {
            if (e.name === d.name) {
              return Object.assign({}, d, {
                active: !e.active
              })
            } else {
              return d
            }
          })
          // console.log(data)
          maxY = d3.max(data.filter(d => d.active).map(d => {
            return d.hour.lineHour.map(d => d.num)
          })
            .reduce((a, b) => {
              return a.concat(b)
            }, []))
          yExt = [0, maxY * 1.2]
          y.domain(yExt)
          let all = data.find(e => e.name === '全部').active
          if (all) {
            tipsMaxMin.style('opacity', 1)
          } else {
            tipsMaxMin.style('opacity', 0)
          }
          yAxis
            .scale(y)
          yAxes.call(yAxis)

          renderLegends()
          renderLines()
          renderPointer()
        })

        // -------------------------------------------------------------------

      let tips = dom.append('div')
        .attr('class', 'tips')
        .style('display', 'none')
      function showTimePointTips (e) {
        let html = ``
        data.forEach(d => {
          // console.log(d)
          if (d.active) {
            html = html + `<div><span class="${d.alias}">${d.name}</span>${toThousands(e[d.alias])}</div>`
            // html = html + '<div><span class="' + d.alias + '">声量</span>' + e[d.alias] + '</div>'
          }
        })
        timePointTips
          .style('opacity', 1)
          .attr('transform', `translate(${margin.left + x(e.publishTime)}, ${margin.top})`)
        tips
          .style('left', `${margin.left + x(e.publishTime)}px`)
          .style('top', `${margin.top + y(e.num) - 50}px`)
        tips.html(
          `<div>${moment(e.publishTime).format('YYYY-MM-DD HH')}</div>
          ${html}
          `)
        tips.style('display', 'block')
      }

      function hideTimePointTips () {
        timePointTips
          .style('opacity', 0)
        tips.style('display', 'none')
      }
      // -------------------------------------------------------------------
      /**
       * zoomed
       */
      // function zoomed () {
      //   let t = d3.event.transform
      //   x.domain(t.rescaleX(xOrigin).domain())
      //   xAxis.tickValues(getXValues(x.domain().map(d => +d), 5))
      //   xAxes
      //     .call(xAxis)
      //
      //   renderLines()
      //   renderPointer()
      //   renderPeriods()
      // }
      // let zoom = d3.zoom()
      //   .scaleExtent([1, Infinity])
      //   .translateExtent([[0, 0], [width, height]])
      //   .extent([[0, 0], [width, height]])
      //   .on('zoom', zoomed)
      // background.call(zoom)
      //
      background
        .on('mousemove', () => {
          let mouse = d3.mouse(d3.event.target)
          let t = +x.invert(mouse[0])
          periodsData.forEach(d => {
            d.active = d.start < t && t < d.end
          })
          renderPeriods()
          let bisectDate = d3.bisector(function (d) { return d.publishTime }).left
          let f = bisectDate(times, t)
          showTimePointTips(tipsValue[f - 1])
        })
        .on('mouseout', () => {
          periodsData.forEach(d => {
            d.active = false
          })
          renderPeriods()
          hideTimePointTips()
        })

      let venations = dom.append('div')
        .attr('class', 'nodes')
        // .style('display', 'none')

      this.showVenations = (display) => {
        venations.selectAll('div.node')
          .style('display', display)
      }

      venations.selectAll('div.node')
        .data(nodes)
        .enter()
        .append('div')
        .attr('class', d => `node node-${d.id}`)

      venations.selectAll('div.node')
        .data(nodes)
        .style('display', 'none')
        .attr('transform', d => `translate(${margin.left + x(d.publishTime)}, ${margin.top})`)
        .style('left', d => `${margin.left + x(d.publishTime)}px`)
        // .style('top', d => `${margin.top + y(data[0].hour.lineHour.find(t => t.publishTime === d.publishTime).num)}px`)
        .style('top', d => `${margin.top + y(data[0].hour.lineHour.find(t => moment(t.publishTime).format('YYYY/MM/DD HH') === moment(d.publishTime).format('YYYY/MM/DD HH')).num)}px`)
        .attr('x', d => margin.left + x(d.publishTime))
        // .attr('y', d => margin.top + y(data[0].hour.lineHour.find(t => t.publishTime === d.publishTime).num))
        .attr('y', d => margin.top + y(data[0].hour.lineHour.find(t => moment(t.publishTime).format('YYYY/MM/DD HH') === moment(d.publishTime).format('YYYY/MM/DD HH')).num))
        .html(d => `<div class="organization">【${d.organization}】</div>
                <div class="content">${d.content}</div>
                <div class="time">${moment(d.publishTime).format('YYYY/MM/DD HH时')}</div>`)

      venations.selectAll('div.node')
        .data(nodes)
        .exit()
        .remove()

      let venationClose = venations.selectAll('div.node')
        .append('i')
        .attr('class', 'el-icon-close')

      venationClose
        .on('click', (e) => {
          venations.select(`div.node-${e.id}`)
            .style('display', 'none')
        })

      function dragStarted (e) {
        console.log('dragStarted', d3.event)
      }
      function dragEnded (e) {
        console.log('dragEnded', d3.event)
      }
      function draged (e) {
        console.log('draged', d3.event)
        let venation = venations.select(`div.node-${e.id}`)
        let x = +venation.attr('x')
        let y = +venation.attr('y')
        console.log(x, y)
        venation
          .style('left', `${x + d3.event.dx}px`)
          .style('top', `${y + d3.event.dy}px`)
          .attr('x', x + d3.event.dx)
          .attr('y', y + d3.event.dy)
      }

      const drag = d3.drag()
        .on('start', dragStarted)
        .on('drag', draged)
        .on('end', dragEnded)

      venations.selectAll('div.node')
        .call(drag)

      svg
        .selectAll('.dot, .dot-text')
        .on('click', (e) => {
          let obj = times.find(d => e.publishTime === d.publishTime)
          let left = x(obj.publishTime)
          let top = y(obj.num)

          let tips = Object.assign({}, e, {
            pos: [left + margin.left, top + margin.top],
            width: w,
            height: h
          })

          if (!this.activeTips.find(d => d.publishTime === e.publishTime)) {
            this.activeTips.push(tips)
          }
        })
    }
  },
  components: {
    VeinTips,
    Loading
  }
}
</script>
<style lang="scss" scoped>
.hour-line {
  position: relative;
  width: 100%;
  height: 100%;
}
.loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.hour-line {
  .domain{
    opacity: 0;
  }
  .tips {
    position: absolute;
    padding:5px;
    width: 150px;
    /*height: 110px;*/
    background: rgba(0,0,0,0.5);
    color:#fff;
    pointer-events: none;
    span {
      margin-right: 15px;
      color: #3989cb;
      &.pos{
        color: #5dca6f;
      }
      &.neu{
        color: #f8c453;
      }
      &.neg{
        color: #ff7676;
      }
    }
  }
  .nodes{
    position: absolute;
    top: 0;
    left: 0;
    .node{
      position: absolute;
      width: 250px;
      padding: 10px;
      border-radius: 5px;
      background-color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      color: #fff;
      cursor: move;
      i{
        position: absolute;
        top: 10px;
        right: 10px;
        &:hover{
          color: #3989cb;
          cursor: pointer;
        }
      }
    }
  }
 .y-axis {
    path {
      opacity: 0;
    }
  }
  .axis {
    text {
      fill:#333;
      font-size: 12px;
    }
  }
  .max-line,
  .mean-line {
    shape-rendering: crispEdges;
  }
  .max-name, .max-value, .mean-name, .mean-value{
    font-size: 12px;
  }
  .y-axis .tick line {
    stroke: #e8ebf1;
    stroke-dasharray: 5;
    shape-rendering: crispEdges;
  }
  .x-axis .tick line {
    opacity: 0;
  }
  .legends {
    position: absolute;
    left: 30px;
    top: -30px;
    color:#333;
    font-size: 12px;
  }
  .legend  {
    float: left;
    margin-left: 20px;
    &:first-child{
      margin-left: 0;
    }
    &:hover{
      cursor: pointer;
    }
  }
  .dot {
    margin-right: 9px;
  }

  .dot, .dot-text{

    &:hover{
      cursor: pointer;
    }
  }
  .time-point-tips{
    pointer-events: none;
  }
  .zoom{
  cursor: move;
  fill: none;
  pointer-events: all;
  }
  .periods{
    font-size: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/HourLine.vue